import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular
  .module('cloudX')
  .controller('InviteRelationDirectDebitDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    '$filter',
    '$q',
    '$element',
    'dataCache',
    'close',
    'companyId',
    'relationId',
    inviteRelationDirectDebitDialogCtrl,
  ]);

function inviteRelationDirectDebitDialogCtrl(
  $http,
  appUrls,
  flySvc,
  $filter,
  $q,
  $element,
  dataCache,
  close,
  companyId,
  relationId,
) {
  var vm = this;
  vm.saving = false;
  vm.templates = null;
  vm.templateId = null;
  vm.loading = true;
  $q.all([
    $http
      .get(`${appUrls.api}/api/relation/TwikeyContractTemplates?companyId=${companyId}`)
      .then(({ data }) => data),
  ]).then(
    function([templates]) {
      vm.templates = templates || [];
      vm.loading = false;
    },
    error => {
      flySvc.error(error);
      vm.loading = false;
    },
  );

  vm.save = function() {
    if (vm.saving) return '';
    vm.saving = true;
    $http
      .post(
        `${appUrls.api}/api/relation/DirectDebitInvite?id=${relationId}&contractTemplate=${vm.templateId}`,
      )
      .then(
        function(result) {
          flySvc.success('msgDirectDebitInviteSent');
          $element.modal('hide');
          close(null, 500);
        },
        error => {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
